import React, { useState } from 'react';
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import {UserContext, UserProvider} from './utils/usercontext';

import Header from './routes/header';
import Footer from './routes/footer';

import HomePage from './routes/index';
import Restream from './routes/services/restream';
import EmojiCrew from './routes/services/emojicrew';
import EmojiChat from './routes/services/emojichat';
import Radio from './routes/services/radio';
import RadioSuite from './routes/services/radiosuite';
import Apply from './routes/radio/apply';
import RadioApply from './routes/radio/radioapply';

import 'bootstrap/dist/css/bootstrap.min.css';
import './routes/css/index.css';
import './routes/css/pricing.css';

function App() {
  const [services] = useState(process.env.NODE_ENV==="production"?['restream', 'radio']:['restream', 'emojicrew', 'emojichat', 'radio', 'radio suite']);
  
  return (
    <UserProvider>
      <BrowserRouter>
        <Header services={services} />
        <Routes>

          {/*---- Home page ----*/}
          <Route path="/" exact element={<HomePage services={services} />} />

          {/*---- Services ----*/}
          <Route path="/restream" exact element={<Restream />} />
          <Route path="/emojicrew" exact element={<EmojiCrew />} />
          <Route path="/emojichat" exact element={<EmojiChat />} />
          <Route path="/radio" exact element={<Radio />} />
          <Route path="/radiosuite" exact element={<RadioSuite />} />

          {/*---- Radio, invites ----*/}
          <Route path="/apply" exact element={<Apply />} />
          <Route path="/apply/:radio" exact element={<RadioApply />} />
          <Route path="/apply/:radio/:code" exact element={<RadioApply />} />

          {/*---- Docs ----*/}


          {/*---- Policies ----*/}

          
        </Routes>
        <Footer services={services} />
        {/*<Socket />*/}
      </BrowserRouter>
    </UserProvider>
  );
}

export default App;
